import AxiosClient from "../AxiosClient";

export const getTax = (params) => {
  const url = "/api/tax/searchInfoList";
  return AxiosClient.post(url, params);
};
